import { FC } from "react";
import { IconProps } from "@/shared/types/icon";
import { Svg, TextColors } from "@abel-technologies-as/components";

export const PlusCircle: FC<IconProps> = (props) => {
	return (
		<Svg width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
			<path
				d="M6.5 4C6.5 3.72386 6.27614 3.5 6 3.5C5.72386 3.5 5.5 3.72386 5.5 4H6.5ZM5.5 8C5.5 8.27614 5.72386 8.5 6 8.5C6.27614 8.5 6.5 8.27614 6.5 8H5.5ZM8 6.5C8.27614 6.5 8.5 6.27614 8.5 6C8.5 5.72386 8.27614 5.5 8 5.5V6.5ZM4 5.5C3.72386 5.5 3.5 5.72386 3.5 6C3.5 6.27614 3.72386 6.5 4 6.5V5.5ZM5.5 4V6H6.5V4H5.5ZM5.5 6V8H6.5V6H5.5ZM8 5.5H6V6.5H8V5.5ZM6 5.5H4V6.5H6V5.5ZM10.5 6C10.5 8.48528 8.48528 10.5 6 10.5V11.5C9.03757 11.5 11.5 9.03757 11.5 6H10.5ZM6 10.5C3.51472 10.5 1.5 8.48528 1.5 6H0.5C0.5 9.03757 2.96243 11.5 6 11.5V10.5ZM1.5 6C1.5 3.51472 3.51472 1.5 6 1.5V0.5C2.96243 0.5 0.5 2.96243 0.5 6H1.5ZM6 1.5C8.48528 1.5 10.5 3.51472 10.5 6H11.5C11.5 2.96243 9.03757 0.5 6 0.5V1.5Z"
				fill={TextColors.BrandSecondary}
			/>
		</Svg>
	);
};
